export enum OrderDeliveryRegion {
  DOMESTIC = "domestic",
  INTERNATIONAL = "international",
  BOTH = "both",
}

export enum OrderDeliveryType {
  REMOTE = "remote",
  BULK = "bulk",
  HYBRID = "hybrid",
}

export const deliveryRegionUsesDomestic = (
  region: OrderDeliveryRegion | null | undefined,
): boolean =>
  region === OrderDeliveryRegion.DOMESTIC || region === OrderDeliveryRegion.BOTH;

export const deliveryRegionUsesInternational = (
  region: OrderDeliveryRegion | null | undefined,
): boolean =>
  region === OrderDeliveryRegion.INTERNATIONAL ||
  region === OrderDeliveryRegion.BOTH;

export const deliveryTypeUsesRemoteCount = (
  type: OrderDeliveryType | null | undefined,
): boolean =>
  type === OrderDeliveryType.REMOTE || type === OrderDeliveryType.HYBRID;

export const deliveryTypeUsesCities = (
  type: OrderDeliveryType | null | undefined,
): boolean =>
  type === OrderDeliveryType.BULK || type === OrderDeliveryType.HYBRID;

/** Orders saved before delivery regions existed only carry a domestic `delivery_type`. */
export const resolveDeliveryRegion = (details: {
  delivery_region?: OrderDeliveryRegion | null;
  delivery_type?: OrderDeliveryType | null;
}): OrderDeliveryRegion | null =>
  details.delivery_region ??
  (details.delivery_type ? OrderDeliveryRegion.DOMESTIC : null);

export const MIN_DELIVERY_LOCATION_COUNT = 1;
export const MIN_INTERNATIONAL_DELIVERY_COUNT = 0;
export const MAX_DELIVERY_LOCATION_COUNT = 100000;

export interface OrderDeliveryCity {
  city_id: number;
  city_name: string | null;
  location_count: number;
}

export interface OrderDeliveryDetails {
  order_id: number;
  delivery_region: OrderDeliveryRegion | null;
  delivery_type: OrderDeliveryType | null;
  /** Domestic remote count; `null` for bulk and international. */
  delivery_location_count: number | null;
  cities: OrderDeliveryCity[];
  delivery_international_remote_count: number | null;
  delivery_international_bulk_count: number | null;
}

export interface DeliveryCityRequest {
  city_id: number;
  location_count: number;
}

export type DomesticDeliveryFields =
  | { delivery_type: OrderDeliveryType.REMOTE; location_count: number }
  | { delivery_type: OrderDeliveryType.BULK; cities: DeliveryCityRequest[] }
  | {
      delivery_type: OrderDeliveryType.HYBRID;
      location_count: number;
      cities: DeliveryCityRequest[];
    };

export interface InternationalDeliveryFields {
  international_remote_count: number;
  international_bulk_count: number;
}

export type UpdateOrderDeliveryRequest =
  | ({
      order_id: number;
      delivery_region: OrderDeliveryRegion.DOMESTIC;
    } & DomesticDeliveryFields)
  | ({
      order_id: number;
      delivery_region: OrderDeliveryRegion.INTERNATIONAL;
    } & InternationalDeliveryFields)
  | ({
      order_id: number;
      delivery_region: OrderDeliveryRegion.BOTH;
    } & DomesticDeliveryFields &
      InternationalDeliveryFields);
